// 群聊——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `expression/index${i + 1}`,
  name: `expressionIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/expression/index${i + 1}.vue`)
}))
const Branch1Routes = Array.from({ length: 3 }, (_, i) => ({
  path: `expression/branch1/index${i + 1}`,
  name: `expressionBranch1Index${i + 1}`,
  component: () => import(`@/views/wxSettings/expression/branch1/index${i + 1}.vue`)
}))
const Branch2Routes = Array.from({ length: 7 }, (_, i) => ({
  path: `expression/branch2/index${i + 1}`,
  name: `expressionBranch2Index${i + 1}`,
  component: () => import(`@/views/wxSettings/expression/branch2/index${i + 1}.vue`)
}))
const Branch3Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `expression/branch3/index${i + 1}`,
  name: `expressionBranch3Index${i + 1}`,
  component: () => import(`@/views/wxSettings/expression/branch3/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 群聊——主流程，开始
    ...MainRoutes,
    // 群聊——分支流程，开始
    ...Branch1Routes,
    // 群聊——分支流程，开始
    ...Branch2Routes,
    // 群聊——分支流程，开始
    ...Branch3Routes,


  ],
};
